import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const values = [
  {
    icon: 'ri-lightbulb-flash-line',
    title: 'Creativity',
    description: 'We push boundaries and think outside the box to deliver unique, innovative solutions that capture attention and inspire action.'
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Integrity',
    description: 'We operate with honesty, transparency, and respect in every client relationship, building trust through consistent excellence.'
  },
  {
    icon: 'ri-trophy-line',
    title: 'Excellence',
    description: 'We are committed to delivering the highest quality work that exceeds expectations and drives measurable results.'
  },
  {
    icon: 'ri-heart-line',
    title: 'Impact',
    description: 'We create designs that make a difference, helping our clients achieve their goals and connect with their audiences meaningfully.'
  }
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <span className="text-[#06B6D4] text-sm font-semibold uppercase tracking-wider">
              About CZ Creative Media
            </span>
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mt-4 mb-6 leading-tight">
              Transforming Visions Into <span className="italic text-[#06B6D4]">Visual</span> Reality
            </h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              We're a creative services company dedicated to helping businesses, churches, and nonprofits stand out through strategic design, impactful signage, and professional print solutions.
            </p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div className="rounded-3xl overflow-hidden">
              <div className="w-full flex items-center justify-center p-12 bg-gray-50">
                <img
                  src="https://static.readdy.ai/image/1a26ac5983f572a98909fa1cfb0c220a/9efa73a4de54dc9e9bbf665ad1b8c213.png"
                  alt="CZ Creative Media Logo"
                  className="w-full h-auto object-contain"
                />
              </div>
            </div>

            <div>
              <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
                Our Story
              </h2>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                Founded nearly two decades ago, CZ Creative Media began with a simple mission: to help organizations communicate their message through powerful visual design. What started as a small screenprinting shop in Norfolk,VA and has grown into a full-service Signs &amp; Graphics company based in South Jersey serving hundreds of clients across the U.S.
              </p>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                We've had the privilege of working with small businesses, churches, nonprofits, and startups each with unique stories to tell and audiences to reach. Our approach combines strategic thinking with creative excellence, ensuring that every project not only looks amazing but also achieves measurable results.
              </p>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                Today, we're proud to be a trusted partner for organizations seeking to elevate their brand presence and make a lasting impact in their communities.
              </p>
              <Link
                to="/contact"
                className="inline-flex items-center bg-gray-900 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-800 transition-all duration-200 hover:shadow-xl whitespace-nowrap group"
              >
                Work With Us
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              Our Core Values
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              These principles guide everything we do and shape how we serve our clients.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {values.map((value, index) => (
              <div
                key={index}
                className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow group"
              >
                <div className="w-16 h-16 bg-[#06B6D4]/10 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-[#06B6D4] transition-colors">
                  <i className={`${value.icon} text-[#06B6D4] text-3xl group-hover:text-white transition-colors`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-4">
                  {value.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
            Ready to Start Your Project?
          </h2>
          <p className="text-xl text-gray-600 mb-10">
            Let's create something extraordinary together.
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center bg-gray-900 text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-gray-800 transition-all duration-200 hover:shadow-2xl whitespace-nowrap group"
          >
            Get In Touch
            <i className="ri-arrow-right-line ml-3 text-xl group-hover:translate-x-1 transition-transform"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}